import { Col, Flex, message, Row } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import type { ImageCapture as ImageCaptureModel } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import type { ImageCaptureAccount } from "@rumble-it/common-lib/types/models/ImageCapture.interface";

import {
  fetchImageCaptureById,
  updateImageCaptureById,
} from "../../../lib/api/resources/imageCaptures";
import { fetchImageCaptureAccounts } from "../../../lib/api/resources/imageCaptureAccounts";
import { ImageCaptureFormCard } from "./components/ImageCaptureFormCard";

export const ImageCaptureEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["imageCapture", id],
    queryFn: () => fetchImageCaptureById(id),
  });

  const { data: accounts, isLoading: isAccountsLoading } = useQuery({
    queryKey: ["imageCaptureAccounts"],
    queryFn: () => fetchImageCaptureAccounts(),
  });

  const accountOptions = Array.isArray(accounts)
    ? accounts.map((acc: ImageCaptureAccount) => ({
        label: acc.title,
        value: acc["@id"],
      }))
    : [];

  const updateImageCaptureMutation = useMutation({
    mutationFn: async (payload: ImageCaptureModel) =>
      updateImageCaptureById(id, payload),
    onSuccess: () => {
      navigate(`/image-captures/${id}`);
      message.success("ImageCapture succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de ImageCapture",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ImageCaptureFormCard
              initialValues={data}
              loading={isLoading || isAccountsLoading}
              mutation={updateImageCaptureMutation}
              title="ImageCapture Bijwerken"
              buttonText="Bijwerken"
              accountOptions={accountOptions}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
